var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-section',{staticClass:"w-100 mt-4",attrs:{"title":"Richieste di stima"}},[_c('estimate-requests-list',{attrs:{"filter":{ no_initiative: true }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }